import { index, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getTimestampWithTimezone,
} from '../common/utils'

export const emailEventTypeEnum = pgEnum('email_event_type', [
  'bounce',
  'complaint',
  'unsubscribe',
])

export const emailEvents = pgTable(
  'email_events',
  {
    ...getBaseFields(),
    email: text().notNull(),
    eventType: emailEventTypeEnum().notNull(),
    messageId: text(),
    bounceType: text(),
    bounceSubType: text(),
    complaintFeedbackType: text(),
    diagnosticCode: text(),
    timestamp: getTimestampWithTimezone().notNull(),
  },
  (table) => [
    ...getBaseIndexes('email_events', table),
    index('email_events_email_idx').on(table.email),
    index('email_events_event_type_idx').on(table.eventType),
    index('email_events_message_id_idx').on(table.messageId),
  ],
)
